<template>
    <div class="section-main22">
        <div class="order-section">
            <h1 v-if="order.close_audit == 1"><span>订单已关闭</span></h1>
            <h1 v-if="order.is_delete"><span>订单已删除</span></h1>
            <h1 v-if="$route.query['type'] && check_type == 1"><span>新增订单审核</span></h1>
            <h1 v-if="$route.query['type'] && check_type == 2"><span>关闭订单审核</span></h1>
            <h1 v-if="$route.query['type'] && check_type == 3"><span>修订订单审核</span></h1>
            <h1 v-if="$route.query['type'] && check_type == 4"><span>补充订单审核</span></h1>
            <div class="order-number order-number2">
                <img class="order-icon" :src="user_avatar">
                <h3>订单ID:<span>{{order.id}}</span></h3>
            </div>
        </div>
        <el-row class="order-pad20">
            <el-col :span="12">
                <el-row :gutter="20">
                    <el-col :span="12" class="order-item">订单类型：<span>{{order.type_memo}}</span></el-col>
                    <el-col :span="12" class="order-item">订单负责人：<span v-for="coper in order.user" :key="coper.user_id" v-show="coper.is_cooperator == 0">{{ coper.name }}</span>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12" class="order-item">客户名称：
                        <span style="color:#1890ff; cursor:pointer;" v-if="Acs('/customers/view')"   @click="handleCustomerView(order.customer_id)" >{{order.customer_name}}</span>
                        <span v-else  >{{order.customer_name}}</span>
                    </el-col>
                    <el-col :span="12" class="order-item">
                        客户手机号：<span>{{order.contact_mobile}}</span>
                        <el-button v-if="order.contact_mobile != ''" type="text" size="mini" icon="el-icon-unlock" @click="unlockMobile(order)">解密</el-button>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12" class="order-item">客户联系人：<span>{{order.contact_name}} {{order.contact && order.contact.job_name ? '(' + order.contact.job_name + ')' : ''}}</span> </el-col>
                    <el-col :span="12" class="order-item" v-if="order.target_id > 0">续约目标单：<a style="color:#1890ff;" @click="handleView(order)">{{ order.target_id }}</a></el-col>
                    <!--<el-col :span="12" class="order-item">备注：<span>{{order.contact_mobile}}</span></el-col>-->
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12" class="order-item">签单模式：<span>{{order.sign_mode_str}}</span></el-col>
                    <el-col :span="12" class="order-item">成交来源：<span>{{order.source_str}}</span></el-col>
                </el-row>
            </el-col>
            <el-col v-if="order.close_audit" :span="12" class="order-item">
                审核状态：
                <div style="color: #909399" v-if="order.close_audit==1">审核通过</div>
                <div style="color: #909399" v-else>待【{{order.close_auditor}}】审核</div>
            </el-col>
            <el-col v-else-if="$route.query['type'] && $route.query['type']==4" :span="12" class="order-item">
                审核状态：
                <div style="color: #909399" v-if="!order.fill_invoice_audit">审核通过</div>
                <div style="color: #909399" v-else>待【{{order.fill_invoice_audit}}】审核</div>
            </el-col>
            <el-col v-else-if="order.type != 1" :span="12" class="order-item">审核状态：<div style="color: #909399" v-html="text"></div></el-col>
        </el-row>
    </div>
</template>
<script>
    import user_avatar from '~/assets/order-icon.png';
    import OrderService from "~/services/order";
    import Config from "~/config/params";
    import ContactService from "~/services/contact";
    export default {
        components: {
            Config,
        },
        props:{
            order:{
                required: true
            },
            check_type:{
                required: true
            }
        },
        data(){
            return {
                text:'',
                user_avatar,
            }
        },
        watch:{
          order(){
              this.text = OrderService.showCheckInfo(this.order);
              return OrderService.showCheckInfo(this.order);
          }
        },
        methods: {
            handleCustomerView(customer_id) {
                this.$router.push({
                    path: "/customers/view",
                    query: {
                        id: customer_id
                    }
                });
            },
            handleView(order) {
                let params = {id: order.target_id};
                if(this.activeTab == 'close'){
                    let flow_type=Config.FINANCE_LINE;
                    if(order.finance_audit==Config.TYPE_CHECKED_FAIL){
                        flow_type = Config.FINANCE_LINE
                    }else if(order.finance_audit==Config.TYPE_CHECKED && order.contract_audit==Config.TYPE_CHECKED){
                        flow_type = Config.CONTRACT_LINE
                    }else if(order.finance_audit==Config.TYPE_CHECKED){
                        flow_type = Config.FINANCE_LINE
                    }
                    params = Object.assign(params,{
                        flow_type:flow_type,
                        type:2,
                        revise_id:0,
                        referer: this.$route.path+"?active=close"
                    })
                }
                let routeData = this.$router.resolve({
                    path: "/order/view",
                    query: params,
                });
                window.open(routeData.href, '_blank');
            },

            unlockMobile(row) {
                ContactService.decodeMobile({id: row.id, type: 4}).then(res => {
                    if (res.code == 0 && res.data) {
                        this.$message.success("解密成功！");
                        if(res.data.mobile > 0){
                            row.contact_mobile = res.data.mobile;
                        }else if(res.data.phone_number > 0){
                            row.contact_mobile = res.data.phone_number;
                        }
                    }
                })
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/partial/order_head.vue